<div class="header" *ngIf="isUserVerified==true" [ngClass]="{'completed' : TaskList.status==4}">
  <img *ngIf="headerImageUrl =='' && TaskListID>0" class="bgimage"
    src="https://storage.flowtrics.com/ecm-userprofile-images/external_task.jpeg" alt="">
  <img *ngIf="headerImageUrl !='' && TaskListID>0" class="bgimage" src="{{headerImageUrl}}" alt="">

  <div *ngIf="TaskListID>0" class="detail">
    <h3>{{getTaskListName(headerText)}}</h3>
  </div>
</div>
<div class="reviewholder" *ngIf="!isUserVerified && completedStatusID>0 && TaskList.status != 4 && taskTemplateID==0">
  <div class="logo">
    <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
  </div>
  <div class="info">

    <h2>Your task list is ready!</h2>
    <h1>{{TaskList.taskListName}}</h1>

    <p *ngIf="TaskID==0"> {{officeName}} shared a task list with you. Please click on the link below to begin the process. When you are
      finished, please click Finish and Submit at the bottom of the provided task list.
    </p>
    <p *ngIf="TaskID>0"> {{officeName}} shared a task with you. Please click on the link below to begin the process. When you are
      finished, please click Finish and Submit at the bottom of the provided task.
    </p>
    <button mat-flat-button color="primary" (click)="startTaskList(taskList,concernedPerson)">
      Let's Start
    </button>
  </div>
</div>

<div class="reviewholder" *ngIf="taskTemplateID>0">
  <div class="logo">
    <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
  </div>
  <div class="info">

    <h2>Create tasklist out of template!</h2>
    <h1>{{templateDetails.taskTemplateName}}</h1>
    <button mat-flat-button color="primary" (click)="AskEmail(taskList)">
      Create
    </button>
  </div>
</div>

<div class="container" *ngIf="isUserVerified">
  <div *ngIf="TaskList.status !== 3" class="welcome">

    <div class="orglogo">
      <img src="../../../assets/images/logo/flowtrics_logo.png" />
    </div>

    <h2>
      <span class="name"> {{TaskList.userName}} from  {{officeName}}</span>
      has assigned you the following tasks.
    </h2>

  </div>


  <!-- <div *ngIf="TaskList.status !== 3" class="requestholder">
    <div class="info">  
  <div class="taskHolder" *ngFor="let taskk of showExternalTaskList">    

  <mat-card-header *ngIf="taskk.taskGroupId>0">{{ taskk.taskGroupName }}</mat-card-header>
  
  <mat-card-content *ngFor="let item of taskk.tasks">
    <h3>{{item.taskTitle}} </h3>
    <p class="taskDes">{{item.description}}</p>
  </mat-card-content>
</div>
  </div>
  </div> -->
  <!-- Open task <span style="background: #8f8f8f;"
  In Progress <span style="background: rgb(253, 171, 61);"
  Completed <span style="background: rgb(0, 200, 117);"  -->

  <div class="totalCount" *ngIf="TaskListID>0">
    <div class="totalCount_list total"> Total task - <span>{{totalTask}}</span></div>
    <div class="totalCount_list open"> Open task - <span>{{openTask}}</span></div>
    <div class="totalCount_list progress"> In Progress - <span>{{inProgressTask}}</span></div>
    <div class="totalCount_list complete"> Completed - <span>{{completedTask}}</span></div>
  </div>
  <div *ngIf="TaskList.status !== 3" class="requestholder" [ngClass]="{'singleTaskHolder': TaskListID <= 0}">
    <div class="info">

      <form [formGroup]="myFormGroup">

        <ng-container *ngFor="let taskk of showExternalTaskList">

          <div class="taskGroup" >

            <h2 *ngIf="taskk.taskGroupId>0">{{ taskk.taskGroupName }}</h2>

            <div class="taskHolder padbtm0" [ngClass]="{'singleTask': TaskListID <= 0}">

              <!-- [ngClass]="{'disabledTask' : task.isDisabled}" -->
              <div class="taskDetail" *ngFor="let task of taskk.tasks">

                <div class="taskName">

                  <div class="taskBar">
                    <div class="taskType">
                      <ng-container *ngIf="task.action == 0">

                        <span class="any">Any</span>
                      </ng-container>
                      <ng-container *ngIf="task.action == 1">

                        <span class="task">Task</span>
                      </ng-container>
                      <ng-container *ngIf="task.action == 2 && !task.isHtmlForm">
                        <span class="fillform">Fill Form</span>
                      </ng-container>
                      <ng-container *ngIf="task.action == 2 && task.isHtmlForm">
                        <span class="htmlform">HTML Form</span>
                      </ng-container>


                      <ng-container *ngIf="task.action == 3">
                        <span class="upload">Upload Documents</span>
                      </ng-container>
                      <ng-container *ngIf="task.action == 4">
                        <span class="video">Watch video</span>
                      </ng-container>
                      <ng-container *ngIf="task.action == 5">
                        <span class="link">Link</span>
                      </ng-container>
                    </div>
                  </div>


                  <!-- <div class="taskIcon">
                    <ng-container *ngIf="task.action == 0">
                      <mat-icon>task_alt</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="task.action == 1">
                      <mat-icon>task</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="task.action == 2 && !task.isHtmlForm">
                      <mat-icon>edit_note</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="task.action == 2 && task.isHtmlForm">
                      <mat-icon>edit_note</mat-icon>
                    </ng-container>


                    <ng-container *ngIf="task.action == 3">
                      <mat-icon>upload_file</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="task.action == 4">
                      <mat-icon>play_circle</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="task.action == 5">
                      <mat-icon>link</mat-icon>
                    </ng-container>
                  </div> -->

                  <ng-container *ngIf="task.action == 1">
                    <!-- <button class="btnAlign" mat-mini-fab color="primary" ><mat-icon>task</mat-icon></button> -->
                    <h3>{{task.taskTitle}} </h3>
                  </ng-container>

                  <ng-container *ngIf="task.action == 2">
                    <a target="_blank" *ngIf="task.isHtmlForm==true"
                      (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)"
                      matTooltip="Fill HTML Form" matTooltipClass="tooltip">{{task.taskTitle}}
                      <mat-icon>open_in_new</mat-icon>
                    </a>

                    <a target="_blank" *ngIf="task.projectID == 0 && task.isHtmlForm!=true"
                      (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)"
                      matTooltip="Create Project" matTooltipClass="tooltip">{{task.taskTitle}}
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                    <ng-container *ngIf="task.projectID > 0 && task.isHtmlForm!=true">

                      <a target="_blank"
                        (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)">{{task.taskTitle}}
                        <mat-icon>open_in_new</mat-icon>
                      </a>
                      <!-- <span class="signNowStyle">Sign Now</span>
                    <button class="btnAlign" style="background-color:#1be06fd9;"   mat-mini-fab color="primary" matTooltip="Sign Now" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)"  matTooltipClass="tooltip">
                      <mat-icon style="font-size: 18px; margin-top:4px" >border_color</mat-icon>
                    </button> -->
                    </ng-container>
                  </ng-container>

                  <ng-container *ngIf="task.action == 4">
                    <a (click)="openVedioLink(task,showVedio)">{{task.taskTitle}}
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                  </ng-container>

                  <ng-container *ngIf="task.action == 5">
                    <!-- <a (click)="openVedioLink(task,showVedio)">{{task.taskTitle}}
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                    xx -->
                    <a (click)="openFormLink(task)">{{task.taskTitle}} <mat-icon>open_in_new</mat-icon></a>
                  </ng-container>

                  <h3 *ngIf="task.action != 2 && task.action != 1 && task.action !=4 && task.action !=5 ">
                    {{task.taskTitle}} </h3>


                  <p class="taskDes">{{task.description}}</p>

                  <div class="documentListing" *ngIf="task.action == 3 && showUpload">

                    <ng-container *ngFor=" let document of task.taskAttachedEntityMapping">
                      <a href="{{document.documentPath}}" target="_blank" matTooltip="{{document.documentName}}"
                        matTooltipClass="tooltip" class="uploadedDocuments">
                        <img src="../../../assets/images/download.png" alt="">
                        <!-- <mat-icon class="descriptionIcon" >description</mat-icon> -->
                        <!-- <mat-icon>downloading</mat-icon> -->

                        <!-- <div class="textIn">
                      <mat-icon>sim_card_download</mat-icon>
                      <span>Download</span>
                    </div> -->
                        <span>{{document.documentName}}</span>
                      </a>
                    </ng-container>

                    <div class="upDoc">
                      <div class="uploadholder">
                        <input #Input type="file" multiple (change)="selectFilesFromDragZone($event, task)" />
                        <div class="textIn">
                          <mat-icon>backup</mat-icon>
                          <span>UPLOAD HERE</span>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="taskAction">
                  <ng-container *ngIf="task.action == 1">
                    <button class="btnAlign" mat-mini-fab color="primary"><mat-icon>task</mat-icon></button>
                  </ng-container>

                  <!-- <ng-container *ngIf="task.action == 2">
              <a class="btnAlign" *ngIf="task.isHtmlForm==true" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)" matTooltip="Fill HTML Form"  mat-mini-fab color="primary" matTooltipClass="tooltip"><mat-icon>edit_note</mat-icon></a>
              
              <a class="btnAlign" *ngIf="task.projectID == 0 && task.isHtmlForm!=true" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)"  matTooltip="Create Project"  mat-mini-fab color="primary" matTooltipClass="tooltip"><mat-icon>edit_note</mat-icon></a>
              <ng-container *ngIf="task.projectID > 0 && task.isHtmlForm!=true">
                  <span class="signNowStyle">Sign Now</span>
                  <button class="btnAlign" style="background-color:#1be06fd9;"   mat-mini-fab color="primary" matTooltip="Sign Now" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)"  matTooltipClass="tooltip">
                    <mat-icon style="font-size: 18px; margin-top:4px" >border_color</mat-icon>
                  </button>
              </ng-container>  
            </ng-container> -->

                  <!-- <ng-container *ngIf="task.action == 4">
              <a (click)="openFormLink(task)" class="btnAlign" mat-mini-fab color="primary"><mat-icon>play_circle</mat-icon></a>
            </ng-container> -->

                  <!-- <ng-container *ngIf="task.action == 5">
                    <a (click)="openFormLink(task)" class="btnAlign" mat-mini-fab
                      color="primary"><mat-icon>link</mat-icon></a>
                  </ng-container> -->

                  <!-- <ng-container *ngIf="task.action == 3">
              <button mat-mini-fab color="primary" class="btnAlign" (click)="showUpload = !showUpload"><mat-icon>upload_file</mat-icon></button>
            </ng-container> -->

                  <!-- <div class="duedate" *ngIf="task.dueDate">
              <label >Due Date</label>
              <div class="dueDate">{{task.dueDate | date:'MM/dd/yyyy'}}</div>
            </div> -->
                  <span class="duedate" *ngIf="task.dueDate">Due Date: {{ getUpdatedDate(task.dueDate)}} </span>
                  <div class="status" style="display: flex;">

                    <!-- <mat-form-field appearance="fill" class="Status_drop">
                <mat-label>Select Status</mat-label>
                <mat-select [disabled]="task.isDisabled" formControlName="status{{task.taskId}}" (selectionChange)="onddlStatusChange($event,task)" >
                  <mat-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                    {{ stat.taskStatusName }}
                  </mat-option>
                </mat-select>          
              </mat-form-field> -->

                    <!-- <label>Task Status</label> -->
                    <ng-select *ngIf="TaskListID>0" appearance="outline" formControlName="status{{task.taskId}}"
                      (change)="onddlStatusChange($event,task)" [searchable]="false" [clearAllText]="false">

                      <ng-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                        <!-- {{ stat.taskStatusName }} -->
                        <span class="statusOptions" [ngStyle]="{'background': stat.background}">{{ stat.id }} {{
                          stat.taskStatusName }}</span>
                      </ng-option>

                    </ng-select>

                    <!-- <span class="statusOptions" [ngStyle]="{'background': stat.background}" > {{ stat.taskStatusName }}</span> -->


                  </div>

                </div>
              </div>
            </div>
          </div>

        </ng-container>
      </form>

    </div>

    <div class="finalAction" *ngIf="taskTemplateID==0">
      <div class="">

        <div class="email" *ngIf="!userFullName">
          {{taskUserEmail}}
        </div>
        <div class="email" *ngIf="userFullName">
          {{userFullName}}
        </div>

      </div>

      <button mat-raised-button *ngIf="TaskListID>0" color="primary" (click)="UpdateTaskOrTaskListstatus()">Save</button>
    </div>

  </div>






  <!-- <div *ngIf="TaskList.status !== 3" class="requestholder">
    <div class="info">      

    <form [formGroup]="myFormGroup">
      <div class="taskHolder"  *ngFor="let taskk of showExternalTaskList">

        <div *ngFor="let task of taskk.tasks">
       
        <div class="taskBar">
          <div class="taskType">
            <ng-container *ngIf="task.action == 0">
              <mat-icon>task_alt</mat-icon>
            </ng-container>
            <ng-container *ngIf="task.action == 1">
              <mat-icon>task</mat-icon>
            </ng-container>
            <ng-container *ngIf="task.action == 2">
              <mat-icon>edit_note</mat-icon>
            </ng-container>
            <ng-container *ngIf="task.action == 3">
              <mat-icon>upload_file</mat-icon>
            </ng-container>
            <ng-container *ngIf="task.action == 4">
              <mat-icon>play_circle</mat-icon>
            </ng-container>
            <ng-container *ngIf="task.action == 5">
              <mat-icon>link</mat-icon>
            </ng-container>
          </div>
        </div>
        <div class="taskDetail">
          <div class="taskName">

            <ng-container *ngIf="taskk.taskGroupId>0">
              {{taskk.taskGroupName}}
            </ng-container>  

            <ng-container *ngIf="task.id!=0">
             <h3>{{task.taskTitle}} </h3>
            </ng-container>
                      
          
           <p class="taskDes">{{task.description}}</p>

            <div class="documentListing" *ngIf="task.action == 3 && showUpload">
              <div class="upDoc">
                <div class="uploadholder">
                  <input #Input type="file" multiple (change)="selectFilesFromDragZone($event, task)" />
                  <div class="textIn">
                    <mat-icon>upload_file</mat-icon>
                  </div>
                </div>
              </div>              
              
              <ng-container *ngFor=" let document of task.taskAttachedEntityMapping">
                <a  href="{{document.documentPath}}" target="_blank" title="{{document.documentName}}" class="uploadedDocuments">
                  <img src="../../../assets/icons/fileType/pdf_icon.svg" alt="">                
                </a>
              </ng-container>             
            </div>
          </div>
        
        <div class="taskAction">
 
          <div class="status" *ngIf="task.dueDate">
            <label >Due Date</label>
            <div class="dueDate">{{task.dueDate | date:'MM/dd/yyyy'}}</div>
          </div>
          
          <ng-container *ngIf="task.action == 1">
            <button class="btnAlign" mat-mini-fab color="primary" ><mat-icon>task</mat-icon></button>
          </ng-container>

          <ng-container *ngIf="task.action == 2">
            <a class="btnAlign" *ngIf="task.isHtmlForm==true" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)" matTooltip="Fill HTML Form"  mat-mini-fab color="primary" matTooltipClass="tooltip"><mat-icon>edit_note</mat-icon></a>
            
            <a class="btnAlign" *ngIf="task.projectID == 0 && task.isHtmlForm!=true" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)" matTooltip="Create Project"  mat-mini-fab color="primary" matTooltipClass="tooltip"><mat-icon>edit_note</mat-icon></a>
            <ng-container *ngIf="task.projectID > 0 && task.isHtmlForm!=true">
                <span class="signNowStyle">Sign Now</span>
                <button class="btnAlign" style="background-color:#1be06fd9;"   mat-mini-fab color="primary" matTooltip="Sign Now" (click)="GetSigningLinkForParticipantIfExists(task,templateRefAccept,signature)" matTooltipClass="tooltip">
                  <mat-icon style="font-size: 18px; margin-top:4px" >border_color</mat-icon>
                </button>
            </ng-container>  
          </ng-container>

          <ng-container *ngIf="task.action == 4">
            <a (click)="openFormLink(task)" class="btnAlign" mat-mini-fab color="primary"><mat-icon>play_circle</mat-icon></a>
          </ng-container>

          <ng-container *ngIf="task.action == 5">
            <a (click)="openFormLink(task)" class="btnAlign" mat-mini-fab color="primary"><mat-icon>link</mat-icon></a>         
          </ng-container>

          <ng-container *ngIf="task.action == 3">
            <button mat-mini-fab color="primary" class="btnAlign" (click)="showUpload = !showUpload"><mat-icon>upload_file</mat-icon></button>
          </ng-container>
         

          <div class="status">           
            <mat-form-field appearance="fill" class="Status_drop">
              <mat-label>Select Status</mat-label>
              <mat-select formControlName="status{{task.tasks.taskId}}" (selectionChange)="onddlStatusChange($event,task.tasks)">
                <mat-option *ngFor="let stat of taskStatusList" [value]="stat.taskStatusID">
                  {{ stat.taskStatusName }}
                </mat-option>
              </mat-select>          
            </mat-form-field>
          </div>
          
        </div>
       </div>
      </div>
    </div>
    </form>
    
    </div>

    <div class="finalAction">
      <button mat-raised-button color="primary" (click)="UpdateTaskOrTaskListstatus()">Save</button>     
    </div>

  </div> -->

  <div class="Wrapper" *ngIf="TaskList.status === 3">
    <h3>Thanks for finising the task list!</h3>
    <h5> You'll Receive an confirmation email once all task are verified.</h5>
    <div class="emailImg">
      <img src="../../../assets/images/thanksEmail.png" alt="">
    </div>
    <a class="register" href="http://flowtrics.com/" mat-stroked-button color="primary" type="button">Get Started</a>
  </div>

</div>

<div class="completeMessage" *ngIf="TaskList.status==completedStatusID">
  <mat-icon>done_all</mat-icon> Tasklist is already completed.
</div>



<ng-template #taskList>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    <span *ngIf="verifyToken==0">
      Provide Details for Authentication
    </span>
    <span *ngIf="verifyToken>0">
      Provide Token for Validation
    </span>

    <button mat-icon-button (click)="closeEmailPopup()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>

    <ng-container *ngIf="showAuthenticationType">
      <div class="title">Send token via</div>

      <div class="authopt">
        <mat-radio-button value="1" [checked]="true" color="primary" (change)="getTokenEmail($event)">
          <div class="thisinfo emailauth" fxLayoutAlign="start center" fxLayout="row">
            <mat-icon>email</mat-icon>
            <h3>Get code on email</h3>
          </div>
        </mat-radio-button>
        <mat-radio-button value="2" color="primary" (change)="getTokenMobile($event)">
          <div class="thisinfo smsauth" fxLayoutAlign="start center" fxLayout="row">
            <mat-icon>stay_current_portrait</mat-icon>
            <h3>Get code on sms</h3>
          </div>
        </mat-radio-button>
      </div>
    </ng-container>

    <mat-form-field *ngIf="verifyToken==0" class="example-full-width">
      <mat-label>Name <span style="color:red"></span></mat-label>
      <input matInput required placeholder="Enter Name" [(ngModel)]="userFullName" />
    </mat-form-field>
    <mat-form-field *ngIf="verifyToken==0" class="example-full-width">
      <mat-label>Email <span style="color:red"></span></mat-label>
      <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified()"
        [(ngModel)]="userEmailForCode" />
    </mat-form-field>

    <mat-form-field *ngIf="showMobile" class="example-full-width">
      <mat-label>Mobile No. <span style="color:red"></span></mat-label>
      <input matInput placeholder="Enter Mobile No." required type="text" [(ngModel)]="authenticationMobile" />
    </mat-form-field>

    <mat-form-field *ngIf="verifyToken>0" class="example-full-width">
      <mat-label *ngIf="Mobilesendtoken==false">Enter token sent to email</mat-label>
      <mat-label *ngIf="Mobilesendtoken==true">Enter token sent to mobile no.</mat-label>
      <input matInput placeholder="Enter token" required type="email" [(ngModel)]="tokenValue" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeEmailPopup()">Cancel</button>
    <button mat-flat-button *ngIf="verifyToken==0" class="calltoaction"
      [disabled]="!isEmailVerified || userFullName.trim()==''" type="submit" color="primary"
      (click)="SendVerfyTokenMethod(concernedPerson)">
      Send Token
      <mat-icon *ngIf="spinner1"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>
    <button mat-flat-button class="calltoaction" *ngIf="verifyToken>0" type="submit" color="primary"
      (click)="getConcernedConfirmation(concernedPerson)">Verify Token</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #participantPopup let-data>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>edit</mat-icon></span>
    Sign or Copy Link to Sign for Participants
    <button mat-icon-button (click)="closeParticipantPopup()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <div *ngFor="let participant of data.participantWithSigningLinkList" class="participant-item">
      <ng-container *ngIf="participant.email && participant.email.trim() !== ''; else showName">
        <span>{{participant.email}}</span>
      </ng-container>
      <ng-template #showName>
        <span *ngIf="participant.name && participant.name.trim() !== ''">{{participant.name}}</span>
      </ng-template>

      <span style="color: green; font-weight: bold;" *ngIf="participant.status==1">
          Signed
      </span>&nbsp;

      <button *ngIf="participant.status==1" mat-flat-button color="primary" (click)="signParticipantDocument(participant.signingToken)">
        View
      </button>

      <button *ngIf="participant.status==0" mat-flat-button color="primary" (click)="signParticipantDocument(participant.signingToken)">
        Sign Now
      </button>
      <button mat-icon-button (click)="copyParticipantTokenToClipboard(participant.signingToken)">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeParticipantPopup()">Close</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #concernedPerson>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Confirmation of Concerned Party
    <button mat-icon-button (click)="closeEmailPopup()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <h4 class="concerned">Are you the person the current tasklist is designed for? <br> (Otherwise, you are a party
      invited on behalf of the person this is created for)
    </h4>

  </mat-dialog-content>
  <mat-dialog-actions class="concerned_btn" align="center" fxLayout="row" fxLayoutAlign="center">
    <button mat-stroked-button color="basic" (click)="noConcernedPerson()">No</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
      (click)="yesConcernedPerson(getUserDetail)">Yes</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #getUserDetail>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Provide Information
    <button mat-icon-button (click)="closeEmailPopup()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>

    <mat-form-field class="example-full-width">
      <mat-label>Full Name</mat-label>
      <input matInput required placeholder="Enter first name" [(ngModel)]="userFullName" />
    </mat-form-field>


    <mat-form-field class="example-full-width">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified3c()"
        [(ngModel)]="userEmailForTaskList" />
    </mat-form-field>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeEmailPopup()">Cancel</button>
    <button mat-flat-button class="calltoaction" [disabled]="!userEmailVerifiedForTaskList" type="submit"
      color="primary" (click)="allDetailsCollected()">Save</button>
  </mat-dialog-actions>
</ng-template>


<app-loader></app-loader>


<div class="progress-loader" *ngIf="spinner">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>

<ng-template #signature>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>group_add</mat-icon></span>
    Add emails of participants
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="signaturePanel">
      <div class="esign">
        <div class="panel" *ngIf="participantMessageInfo!=null">
          <div class="example-list">
          </div>
          <div class="groupHolder">
            <div cdkDropList class="example-list">
              <div class="groupheading" (click)="getToogleInformation()">
                <h2>
                  <mat-icon>message</mat-icon>Information
                </h2>
                <button mat-icon-button> <mat-icon>expand_more</mat-icon> </button>
              </div>
              <div class="moveblock example-box" cdkDrag>
                <div id="participantMessageDiv" [ngClass]="{'active' : toogleInformation}"
                  innerHtml="{{participantMessageInfo}}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel">

          <div class="groupHolder" *ngFor="let p1 of projectGroups">

            <div id="{{p1.groupName}}" class="example-list">

              <div class="groupheading">
                <h2 *ngIf="p1.groupType ==1">
                  <mat-icon>create</mat-icon>{{p1.groupName}}
                </h2>

                <h2 *ngIf="p1.groupType !=1">
                  <mat-icon>description</mat-icon>{{p1.groupName}}
                </h2>

              </div>

              <div *ngIf="p1.projGrpRelationParticipantList.length == 0" class="moveblock example-box">
                <p class="nocontent">No relationship added</p>
              </div>

              <div *ngFor="let p of p1.projGrpRelationParticipantList" class="moveblock example-box">

                <div class="Colrd" [ngStyle]="{'background-color': p.colourCode }">
                  <mat-icon *ngIf="p.typeOfParticipant==0">email</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==4">person</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==5">work</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==1">app_registration</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==2">contact_mail</mat-icon>
                  <mat-icon *ngIf="p.typeOfParticipant==3">business</mat-icon>
                </div>

                <div class="userInfo">
                  <div class="chipss">
                    <mat-chip-list>
                      <mat-chip> {{p.relationName}} </mat-chip>
                    </mat-chip-list>
                  </div>


                  <div class="selectContact" *ngIf="p.participantName || p.roleName || p.contactEmail">
                    <div class="userpic" *ngIf="p.participantImageURL">
                      <img [src]="p.participantImageURL" alt="" />
                    </div>

                    <div class="userpic" *ngIf="!p.participantImageURL">
                      <span class="shortName"
                        *ngIf="p.participantName">{{getShortName(p.participantName,'participant')}}</span>
                      <span class="shortName" *ngIf="!p.participantName">{{getShortName(p.roleName,'role')}}</span>
                      <span class="shortName" *ngIf="!p.participantName">{{getShortName(p.contactEmail,'email')}}</span>
                    </div>

                    <div class="info">
                      <p *ngIf="p.participantName">{{ p.participantName }} </p>
                      <p *ngIf="!p.participantName">{{p.contactEmail}}</p>
                      <p *ngIf="!p.participantName">{{p.roleName}}</p>
                    </div>

                    <button class="removeContact" mat-icon-button color="basic" (click)="RemoveRelation(p)">
                      <mat-icon>close</mat-icon>
                    </button>

                  </div>

                  <ng-container *ngIf="!p.participantName && !p.roleName &&  !p.contactEmail">
                    <button mat-icon-button color="primary" class="personadd"
                      (click)="assignUser(addAssigne,true,false,'',p,p1)">
                      <mat-icon>person_add</mat-icon>
                    </button>
                    <span class="addEmail" (click)="assignUser(addAssigne,true,false,'',p,p1)">Add email</span>
                  </ng-container>

                </div>
                <div class="Cancel">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <span>
      <button mat-flat-button color="primary" [disabled]="!SendButtonDisabled"
        (click)="ProjectSend(templateRefAccept,signature)">Send</button>
    </span>
  </mat-dialog-actions>
</ng-template>


<ng-template #addAssigne>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Participant
    <button mat-icon-button (click)="closeAssignParticipant()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container>
      <form class="example-form">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search contact or type email</mat-label>
          <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
            (input)="searchUserProject($event.target.value)" id="stateCtrlid">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option (click)="contactSelected(contact)" *ngFor="let contact of contactsList" [value]="contact.name">
              <span class="userlist" style="display: flex;" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="userpic">
                  <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                  <span class="username" *ngIf="contact.imageUrl==''" class="username">
                    {{contact.shortName}}
                  </span>
                </div>
                <div class="info1">
                  <p> {{ contact.name }}</p>
                </div>
              </span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeAssignParticipant()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateParticipants()">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #templateRefAccept>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>supervised_user_circle</mat-icon>
    </span>
    Accept
    <button mat-icon-button (click)="closeAssign()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container>
      <div class="reviewholderAccept">
        <div class="logo">
          <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div>
        <div class="info">
          <h2>Please review and act on these documents.</h2>
          <p>By Clicking on this link you agree to use electronic records and signatures.</p>
          <button mat-flat-button color="primary" (click)="IscreateProject(signature)">Accept </button>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>
</ng-template>

<ng-template #showVedio>
  <mat-dialog-content class="mat-typography">
    <ng-container>
      <iframe [src]='safeSrcVedio' width="100%" height="315" frameborder="0" webkitallowfullscreen mozallowfullscreen
        allowfullscreen></iframe>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="closeVedio()">Cancel</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #singleTaskTemp>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    Provide Email
    <!-- <button mat-icon-button (click)="closeEmailPopup()">
      <mat-icon>close</mat-icon>
    </button> -->
  </h2>
  <mat-dialog-content>   

    <mat-form-field class="example-full-width">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified3c()"
        [(ngModel)]="userEmailForTaskList" />
    </mat-form-field>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <!-- <button mat-button color="basic" (click)="closeEmailPopup()">Cancel</button> -->
    <button mat-flat-button class="calltoaction" [disabled]="!userEmailVerifiedForTaskList" type="submit"
      color="primary" (click)="proceedSingleTaskTemp()">Proceed</button>
  </mat-dialog-actions>
</ng-template>